angular.module('mtic').service('moduleMappingService', function ($log) { 
    var c3v2_map = {
        "mtic_c3_m1_diagnostic":"mtic_c3_m1_diagnostic",
        "mtic_c3_m1v2_4stages":null,
        "mtic_c3_m1v2_aquarium":"mtic_c3_m1_fish",
        "mtic_c3_m1v2_lemurs":"mtic_c3_m1_lemur",
        "mtic_c3_m1v2_stickers":"mtic_c3_m1_sticker",
        "mtic_c3_m1v2_bike":"mtic_c3_m1_bike_tachometer",
        "mtic_c3_m1v2_granny":"mtic_c3_m1_car_tachometer",
        "mtic_c3_m1v2_jump":"mtic_c3_m1_jump",
        "mtic_c3_m1v2_zooshop":"mtic_c3_m1_souvenir_b",
        "mtic_c3_m1v2_skate":"mtic_c3_m1_skateshop",
        "mtic_c3_m1v2_camp":"mtic_c3_m1_camping",
        "mtic_c3_m1v2_elephants":"mtic_c3_m1_elephants",
        "mtic_c3_m1v2_train":"mtic_c3_m1_train_paris",
        "mtic_c3_m1v2_plane":"mtic_c3_m1_airplane_porto",
        "mtic_c3_m1v2_tower":"mtic_c3_m1_block_tower",
        "mtic_c3_m1v2_stuffedanimal":"mtic_c3_m1_souvenir_c",
        "mtic_c3_m1v2_tram":"mtic_c3_m1_tram",
    }
    return {
        getC3Mapping(orig_map){
            var c3v1, c3v2;
            _.each(orig_map.resources, function(mod){
            if(mod.slug === 'mtic_c3_m1'){
                c3v1 = mod;
            }else if(mod.slug === 'mtic_c3_m1v2'){
                c3v2 = mod;
            }
            })
            if(c3v2 && c3v2.children && c3v1 && c3v1.children){
                _.each(c3v2.children, function(resource){
                    if(c3v2_map[resource.slug]){
                        _.each(c3v1.children, function(v1_resource){
                        if(c3v2_map[resource.slug] === v1_resource.slug){
                            resource.complete = resource.complete || v1_resource.complete;
                            if(resource.resourceState && v1_resource.resourceState){
                                resource.resourceState.completions = resource.resourceState.completions + v1_resource.resourceState.completions;
                                resource.resourceState.complete = resource.resourceState.complete || v1_resource.resourceState.complete;
                                resource.resourceState.score_max = Math.max(resource.resourceState.score_max, v1_resource.resourceState.score_max)
                            }else if(v1_resource.resourceState){
                                resource.resourceState = v1_resource.resourceState;
                            }
                        }
                        })
                    }
                })
            }
            return orig_map;
        }
    }
})